import { render, staticRenderFns } from "./SingleImportPrivate.vue?vue&type=template&id=1541c5fa"
import script from "./SingleImportPrivate.vue?vue&type=script&lang=js"
export * from "./SingleImportPrivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports